import { Grid } from '@material-ui/core';

import SelectMembers from '../solicitations/select.members.component';
import RequestReviewResponsibles from './request.review.responsibles.component';

function RequestResponsibleComponent({ request, refresh }) {

    return (
        <Grid container>

            <SelectMembers
                requestId={request.id}
                requestInfo={{ city: request.city, serviceId: request.serviceId, isInCorrection: request.isInCorrection }}
                serviceId={request.serviceId}
                step={request.status}
                linkHold={request.linkHold}
                members={request.members}
                onRefreshRequest={refresh}
            />

            <RequestReviewResponsibles request={request} refresh={refresh} />

        </Grid>
    );
}

export default RequestResponsibleComponent;
